import React from "react"
import { Link, graphql } from "gatsby"
import Img from "gatsby-image"
import { TimelineLite, Elastic } from "gsap"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Bio from "../components/bio"
import CategoryList from "../components/categoryList"
import RecentPosts from "../components/recentPosts"

import '../scss/pages/index.scss'
import '../scss/components/sidebar.scss'
import "../scss/components/blogPosts.scss"

class BlogIndex extends React.Component {
  constructor(props) {
    super(props)
    this.postTween = new TimelineLite({delay: 0.2})
    this.postItems = []
  }
  componentDidMount() {
    this.postTween.staggerTo(this.postItems, 1 , { ease: Elastic.easeOut.config(1, 0.4) , y:0, opacity: 1} , 0.1)
  }
  render() {
    const { data } = this.props
    const siteTitle = data.site.siteMetadata.title
    const mainogp = data.site.siteMetadata.mainogp
    const siteUrl = data.site.siteMetadata.siteUrl
    const posts = data.allContentfulBlogPost.edges


    return (
      <Layout location={this.props.location} title={siteTitle}>
        <SEO
          title="Top"
          keywords={[`福岡`, `クリエイター`, `photography`, `travel`, `webdesign`, `filmmaking`]}
          thumbnail={`${siteUrl}${mainogp}`}
        />
        <main className="indexWrap">
          {posts.map(( post, index ) => {

          const title = post.node.title || post.node.slug
          return (
            <div className="post" key={post.node.slug} ref={div => this.postItems[index] = div}>
              <Link to={`/${post.node.slug}`}>
                <div className="postImg">
                  <Img fluid={post.node.thumbnail.fluid} />
                </div>
                <div className="postText">
                  <h3>
                    {title}
                  </h3>
                  <span className="postMeta">
                    <time>{post.node.createdAt}</time>
                    <span className={post.node.category}>{post.node.category}</span>
                  </span>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: post.node.description || post.node.excerpt,
                    }}
                  />
                </div>
              </Link>
            </div>
          )
        })}
        </main>
        <aside className="sidebar">
          <Bio />
          <CategoryList />
          <RecentPosts />
        </aside>
      </Layout>
    )
  }
}

export default BlogIndex

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
        mainogp
        siteUrl
      }
    }
    allContentfulBlogPost(
			sort: { fields: [createdAt], order: DESC }
		) {
      edges {
        node {
          title
          description
					slug
					category
					createdAt(formatString: "YYYY.MM.DD")
          thumbnail {
            fluid {
              ...GatsbyContentfulFluid
            }
          }
        }
      }
    }
  }
`
